module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAALCAMAAACqC0YIAAAAjVBMVEUAAAAAAACAgIBxcXGLi4uEhISMjIyEiYSGi4aGhoaGhoaKioqFiYWJiYmIiIiJiYmIiIiIiIiJiYmIiIiJiYmIiIiIiIiHiYeJiYmIioiHiYeIioiIioiIiYiIiYiIiYiIiYiIiIiJiYmHiIeHiIeIiYiIiYiIiYiHiIeIiYiHiIeIiYiIiYiIiYiIiYiwzFKWAAAALnRSTlMAAQQJFh8oNDk9Pz9BTl5ub3h7fH2Bg4aIi5OjsrzJy9LZ4uTq6+7v8fT3+vv9bW1inQAAAGdJREFUCB0FwQUCggAQALCZIAo2dhco3P+f52YzBwB6p6tH7ACge4yz5B1bADqHuPVJPlEC2Md9AGkVJWAdryGQVlGCWVQJQFrFEkX7nQAwqmMhb5ocALI6Lr+2AACyOmIKADB+rgD+sGwIUG63o3wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/arraw.png
// module id = SQe7
// module chunks = 1